import { authenticatedFetch } from '../../api/request';

export default function getInvoices(orgId: number) {
    const url = `/v5/orgs/${orgId}/account/invoices`;

    return authenticatedFetch(url);
}
